import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import DiscountTag from './DiscountTag';
import GameTags from '../game/GameTags';
import { NavLink } from '../../../lib/Navigation';

export default function PopularNowadays(props) {

  const { item } = props;

  return (
    <div>
      <div style={{paddingTop:'10px'}}>
        <Swiper slidesPerView={'auto'} spaceBetween={'-15%'} >
          {item.popularlist.map((game, index) => (
            <SwiperSlide key={index}>
              <div>
                {game.map((obj, index) => {
                  return (
                    <NavLink user={false} to={`game?id=${obj.game_id}`} key={index} style={{ paddingBottom: index == game.length - 1 ? '0' : '15px', display:'block',width:'85%' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={obj.game_image.thumb} alt={obj.game_name} height={66}/>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0 10px', overflow: 'hidden' }}>
                          <p style={{ fontSize:'0.32rem',color:'#282828',fontWeight:500}}>{obj.game_name}</p>
                          <div style={{ display: 'flex', alignItems: 'center',padding:'1px 0 2px', width: '100%' }}>
                            <DiscountTag>{obj}</DiscountTag>
                            <div style={{fontSize:'0.22rem',color:'#999',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{obj.game_classify_type.trim()}
                              {obj.nameRemark && <span style={{fontSize:'0.22rem',color:'#999',paddingLeft:5}}> · {obj.nameRemark}</span>}
                            </div>
                          </div>
                          <GameTags game={obj}></GameTags>
                          <div></div>
                        </div>
                      </div>
                    </NavLink>
                  );
                })}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
